import {
    Permission,
    ReportTemplateEntityType,
    ReportTemplatePageMarginUnit,
    ReportTemplatePageOrientation,
    ReportTemplatePageSize,
    SwarmType,
} from '@/graphql/types';
import { isSomeEnum } from '../../../utils/is-some-enum';

export const isReportTemplatePageSize = isSomeEnum(ReportTemplatePageSize);
export const isReportTemplatePageOrientation = isSomeEnum(ReportTemplatePageOrientation);
export const isReportTemplatePageMarginUnit = isSomeEnum(ReportTemplatePageMarginUnit);
export const isReportTemplateEntityType = isSomeEnum(ReportTemplateEntityType);
export const isSwarmType = isSomeEnum(SwarmType);
export const isPermission = isSomeEnum(Permission);

export function isDefinitionField(field: { type: string }): boolean {
    return field.type === 'definitions';
}
